// extracted by mini-css-extract-plugin
module.exports = {"promo":"_3lIIEwZ7 _1EH-ihlL _1b_LYj1U","total":"UfMPTQ-t _1EH-ihlL _6nDx13vE _3AjOtQJQ"};